const hideZeroReviewsInterval = setInterval(() => {


  const bvStars = document.querySelectorAll('.klevuProduct');


  if (bvStars.length > 0) {
    let allLoaded = true;

    
    bvStars.forEach(el => {
      // If the review container is still empty, skip for now
      if (!el.textContent.trim()) {
        allLoaded = false;
         
      }
    });

    if (allLoaded) {
      //clearInterval(hideZeroReviewsInterval);

      $('.kuResults .klevuProduct').each((index, product) => {
          const product_review = $(product).find('.star-rating-klevu');
          const review_text = product_review.find('.bv_averageRating_component_container .bv_text').text().trim();
                        
          if (review_text === "0.0" || review_text === "0") {
            
            product_review.hide();
          }
        });
      
    }
  }
}, 300);


const hideCollecTagOnPharmacyProducts = setInterval(() => {


  const bvStars = document.querySelectorAll('.klevuProduct');


  if (bvStars.length > 0) {
    let allLoaded = true;

    
    bvStars.forEach(el => {
      // If the review container is still empty, skip for now
      if (!el.textContent.trim()) {
        allLoaded = false;
         
      }
    });

    if (allLoaded) {
      //clearInterval(hideCollecTagOnPharmacyProducts);

      $('.kuResults .klevuProduct').each((index, product) => {
          const product_Div_calss = $(product).find('.collection-product-item');
          const dataID = product_Div_calss.attr('data-id');
          const clickCollectlabel = $(product).find('span.product-label.product-label--custom1.product-label--northwood');
        
          if (product_Div_calss.hasClass('isPharmacistOnlyTag')) {
            
          }else{
            clickCollectlabel.show();
          }
        });

    }
  }
}, 300);

const hideReviewsProductInterval = setInterval(() => {
 
  const bvStars = $('.product-block-list__item--info');

  if (bvStars.length > 0) {
    let allLoaded = true;

    bvStars.each(function () {
      if (!$(this).text().trim()) {
        allLoaded = false;
        return false; // break the loop early
      }
    });

    if (allLoaded) {
      const productReview = $('.bv_main_container');
      const reviewText = productReview.find('.bv_numReviews_text').text().trim();

      const ratingSummaryDiv = document.querySelector('div[data-bv-show="rating_summary"]');
            
      console.log(reviewText);
      
      if ( reviewText === "0" || reviewText === "" ) {
      }
        else if(reviewText == "(0)"){
          bvStars.addClass('stoploop');
        console.log('class added');
        }
      else{
        ratingSummaryDiv.style.setProperty('display', 'block');
        bvStars.addClass('stoploop');
        console.log('class added');
      }

      if(bvStars.hasClass('stoploop')){
        clearInterval(hideReviewsProductInterval); // ✅ clear the interval after done
        console.log('Checking reviews stopped');
      }
      
    }
  }
}, 300);

// const hideReviewsProductInterval = setInterval(() => {


//   const bvStars = document.querySelectorAll('.product-block-list__item--info');


//   if (bvStars.length > 0) {
//     let allLoaded = true;


//     bvStars.forEach(el => {
//       // If the review container is still empty, skip for now
//       if (!el.textContent.trim()) {
//         allLoaded = false;

//       }
//     });

//     if (allLoaded) {
//       //clearInterval(hideCollecTagOnPharmacyProducts);


//           const product_review = $(product).find('.bv_main_container');
//           const review_text = product_review.find('.bv_numReviews_text').text().trim();

//           if (review_text === "0.0" || review_text === "0") {

//             product_review.hide();

//           }


//     }
//   }
// }, 300);



// updated holiday hours on location page

document.addEventListener("DOMContentLoaded", function () {

    var specialHoursData = {
        "Manukau": [
            { date: "24 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "27–31 Dec", hours: "8am - 8pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Pakuranga": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "27–31 Dec", hours: "8am - 8pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Pukekohe": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "27–31 Dec", hours: "8am - 7pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "WestCity": [
            { date: "24 Dec", hours: "9am - 7pm" },
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 7pm" },
            { date: "27 Dec", hours: "9am - 6pm" },
            { date: "28 Dec", hours: "10am - 5.30pm" },
            { date: "29–31 Dec", hours: "9am - 6pm" },
            { date: "1–2 Jan", hours: "10am - 6pm" }
        ],

        "Westgate": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "27–31 Dec", hours: "8am - 8pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Whangaparaoa": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "27–31 Dec", hours: "8am - 8pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Pinehill": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "27–31 Dec", hours: "8am - 8pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Mt Roskill": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "27–31 Dec", hours: "8am - 8pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Mt Wellington": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "27–31 Dec", hours: "8am - 8pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Te Awamutu": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "New Plymouth": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "1 Jan", hours: "CLOSED" },
            { date: "2 Jan", hours: "9am - 6pm" }
        ],

        "Whanganui": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "1 Jan", hours: "9am - 6pm" }
        ],

        "Porirua": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Wellington CBD": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Petone": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Upper Hutt": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Lyall Bay": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Shirley": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Northwood": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Tower Junction": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 6pm" },
            { date: "1–2 Jan", hours: "9am - 6pm" }
        ],

        "Eastgate": [
            { date: "22–23 Dec", hours: "8am - 7pm" },
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 5pm" },
            { date: "31 Dec", hours: "9am - 5pm" },
            { date: "1–2 Jan", hours: "9am - 5pm" }
        ],

        "South Dunedin": [
            { date: "25 Dec", hours: "CLOSED" },
            { date: "26 Dec", hours: "9am - 5pm" },
            { date: "1–2 Jan", hours: "9am - 5pm" }
        ]
    };


    var locationNameEl = document.querySelector(".selected-location--name");
    console.log('fdg', locationNameEl);
    if (!locationNameEl) return;

    var locationName = locationNameEl.textContent.replace("Bargain Chemist", "").trim();
    var specialHours = specialHoursData[locationName];
    if (!specialHours) return;

    var containers = document.querySelectorAll(".selected-location--special-hours");
    containers.forEach(function (container) {

        specialHours.forEach(function (entry) {
            var row = document.createElement("div");
            row.className = "selected-location--hours-line";

            row.innerHTML = `
        <span class="selected-location--hours-day">${entry.date}</span>
        <span class="selected-location--hours">${entry.hours}</span>
      `;

            container.appendChild(row);
        });

    });

});


// StoreLocator js

document.querySelector('.location-input').addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
        event.preventDefault(); // Prevent the default form submission
        const searchButton = document.querySelector('.find-store');
        if (searchButton) {
            searchButton.click(); // Trigger the click event on the search button
        }
    }
});